import AnalyzePerformanceChart from "./AnalyzePerformanceChart";
import "./AnalyzePerformanceChart.scss";

export default AnalyzePerformanceChart